import styled from 'styled-components'

import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'

export const Input = styled(TextField)`
  min-width: 150px;
  margin: 0;

  &, label {
    color: ${ colors.link };
    font-size: ${ fonts.fontSize.S }px;
    font-weight: ${ fonts.fontWeight.bold };
  }
`

export const SelectHarvest = styled(Autocomplete)`
  .MuiInputLabel-shrink {
    color: ${ colors.mutedText };
    font-weight: ${ fonts.fontWeight.regular };
  }

  .MuiInputBase-input {
    color: ${ colors.link };
    font-size: ${ fonts.fontSize.S }px;
    font-weight: ${ fonts.fontWeight.bold };

    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }

  .MuiInput-underline {
    &:after,
    &:before,
    &:hover,
    &:hover:not(.Mui-disabled):before {
      border-bottom: 0;
    }
  }

  .MuiAutocomplete-endAdornment {
    svg path {
      color: ${ colors.link };
    }
  }
`
